import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './CelebrityPopup.css'

import { vrtApiRequest } from '../../httpClient';

import { setJoinModalState } from '../../store/reducers/SessionReducer';

function CelebrityPopup() {
  const dispatch = useDispatch()

  const token = useSelector(state => state.participant.token);
  const joinModalOpened = useSelector(state => state.session.joinModalOpened)

  const connectCelebrity = async () => {
    dispatch(setJoinModalState(false))

    await vrtApiRequest.put('/room/update', { token, availableForCelebrity: true });
  }

  const disconnectCelebrity = async () => {
    dispatch(setJoinModalState(false))

    await vrtApiRequest.put('/room/update', { token, availableForCelebrity: false });
  }

  return (
    <div className={`jp-container ${joinModalOpened ? 'opened' : ''}`}>
      <div className='jp-title'>
        Do you want to meet the celebrity?
      </div>

      <div className='jp-buttons-container'>
        <button
          onClick={connectCelebrity}
        >
          Yes
        </button>

        <button
          onClick={disconnectCelebrity}
        >
          No
        </button>
      </div>
    </div>
  )
}

export default CelebrityPopup;
